import { render } from "./TierArtServicesSettings.vue?vue&type=template&id=b310c1a8&scoped=true"
import script from "./TierArtServicesSettings.vue?vue&type=script&lang=js"
export * from "./TierArtServicesSettings.vue?vue&type=script&lang=js"

import "./TierArtServicesSettings.vue?vue&type=style&index=0&id=b310c1a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b310c1a8"]])

export default __exports__